import { type ReactNode, type Ref } from "react";

import { cn } from "../../utils/cn.util";
import { Tooltip, type TooltipContentProps, type TooltipRootProps } from "../tooltip";

export interface TextEllipsisProps
  extends TooltipRootProps, Pick<TooltipContentProps, "side" | "align" | "sideOffset" | "alignOffset" | "theme"> {
  children: ReactNode;
  content: ReactNode;
  className?: string;
  tooltipClassName?: string;
  showWhenOverflow?: boolean;
  asChild?: boolean;
  disabled?: boolean;
  hideArrow?: boolean;
  ref?: Ref<TextEllipsisProps>;
}

const TextEllipsis = ({
  ref: _ref,
  children,
  content,
  theme,
  side = "right",
  align = "center",
  className,
  tooltipClassName,
  showWhenOverflow = true,
  sideOffset = 5,
  alignOffset = 0,
  disabled = false,
  asChild = true,
  hideArrow = false,
  defaultOpen,
  open,
}: TextEllipsisProps) => {
  return (
    <Tooltip.Root defaultOpen={defaultOpen} open={open}>
      <Tooltip.Trigger
        className={cn("truncate", className)}
        onOverflow={showWhenOverflow}
        asChild={asChild}
        disabled={disabled}
      >
        {children}
      </Tooltip.Trigger>
      <Tooltip.Content
        sideOffset={sideOffset}
        alignOffset={alignOffset}
        theme={theme}
        side={side}
        align={align}
        className={cn(Boolean(content) && "flex max-w-none gap-2 break-words", disabled && "hidden", tooltipClassName)}
      >
        {typeof content === "string" ? <p>{content}</p> : content}
        {hideArrow ? null : <Tooltip.Arrow theme={theme} />}
      </Tooltip.Content>
    </Tooltip.Root>
  );
};

TextEllipsis.displayName = "TextEllipsis";

export default TextEllipsis;
